<section class="centered-with-padding flex flex-col gap-y-5 py-10">
  @if (data.title; as title) {
    <app-title [title]="title" size="h1" />
  }
  @if (!isTimeslotsError() && storeSelected()?.isVisioAppointmentAvailable) {
    <div class="flex flex-col gap-2 desk:flex-row">
      <div>{{ "COMPONENT.AGENDA-MAGASIN-TUNNEL.I_WANT_TO_TAKE_MY_APPOINTMENT" | translate }} :</div>
      <div class="flex gap-x-5">
        <label class="inline-flex cursor-pointer items-center space-x-2">
          <input
            (change)="visioAppointmentSelected.set(false)"
            [checked]="!visioAppointmentSelected()"
            name="rdvMode"
            type="radio" />
          <span>{{ "COMPONENT.AGENDA-MAGASIN-TUNNEL.IN_STORE" | translate }}</span>
        </label>

        <label class="inline-flex cursor-pointer items-center space-x-2">
          <input
            (change)="visioAppointmentSelected.set(true)"
            [checked]="visioAppointmentSelected()"
            name="rdvMode"
            type="radio" />
          <span>{{ "COMPONENT.AGENDA-MAGASIN-TUNNEL.REMOTELY" | translate }}</span>
        </label>
      </div>
    </div>
  }
  @let dates = timeslots();
  @if (!isTimeslotsError() && dates) {
    @for (dateSlot of dates; track dateSlot.dateLabel) {
      <div class="flex flex-col gap-y-3.5 rounded-xl bg-anis px-4 py-5 font-bold desk:gap-y-4">
        <div (click)="toggleSlot(dateSlot.dateLabel)" class="flex cursor-pointer items-center justify-between">
          <span>{{ dateSlot.dateLabel | transformFirstLetter }}</span>
          <app-svg
            [height]="15"
            [inline]="true"
            [ngClass]="{
              'rotate-90': !slotClosed().has(dateSlot.dateLabel),
            }"
            [width]="7"
            class="transition-transform duration-300 ease-in-out"
            src="./assets/icons/caret-right.svg" />
        </div>
        @if (!slotClosed().has(dateSlot.dateLabel)) {
          <div class="flex flex-wrap gap-x-2 gap-y-3.5 desk:gap-y-4">
            @for (slot of dateSlot.formattedSlots; track slot.startDate) {
              <div
                (click)="onSlotClick(dateSlot, slot)"
                class="drop-shadow-custom flex h-9 w-16 cursor-pointer items-center justify-center rounded-[10px] bg-white">
                {{ slot.slot }}
              </div>
            } @empty {
              @if (storeSelected()?.phone; as phone) {
                @let buttonLabel = "GLOBAL.CALL_TO_ACTION_CALL_US" | translate;
                @let gtm = data.gtmConfigCallBtn;
                <a
                  (click)="
                    emitGtmEvent({
                      event: gtm?.event,
                      group: gtm?.group,
                      description: gtm?.description,
                      context: gtm?.context,
                      button_text_value: buttonLabel,
                      event_type: 'click',
                    })
                  "
                  [href]="phone.telLink"
                  class="drop-shadow-custom flex h-9 w-[176px] cursor-pointer items-center justify-center gap-x-2.5 rounded-[10px] bg-white px-2">
                  <span>{{ buttonLabel }}</span>
                  <app-svg [height]="16" src="assets/icons/phone.svg" />
                </a>
              }
            }
          </div>
        }
      </div>
    }
  } @else if (!isTimeslotsError()) {
    <app-loader [text]="'GLOBAL.LOADING_TIME_SLOTS' | translate" />
  } @else if (isTimeslotsError()) {
    <div class="flex justify-center pt-14">
      <app-no-slot-fallback-card [store]="storeSelected()!" />
    </div>
  }
  @if (!isTimeslotsError() && storeSelected()?.phone; as phone) {
    <div class="flex items-center gap-x-2.5 rounded-2xl bg-gray-light p-4">
      <app-svg [inline]="true" [src]="data.contactBanner.picto.svg" [width]="34" />
      <div [innerHTML]="data.contactBanner.text | replaceWholeWord: '#PHONE#' : phone.formatted : true"></div>
    </div>
  }
</section>
